import { createCrudStore } from "@/store/crudStore";
import { apiService } from "@/services/api";

const picadosStore = createCrudStore("picados");

export default {
  ...picadosStore,
  actions: {
    ...picadosStore.actions,
    getPicados: picadosStore.actions.getAllStates,
    postPicado: picadosStore.actions.create,
    patchPicado: picadosStore.actions.update,
    deletePicado: picadosStore.actions.delete,

    // Confirmar un picado pendiente
    async confirmarPicado({ dispatch }, { picadoId, payload }) {
      return await dispatch("executeApiCall", {
        apiCallFunction: () =>
          apiService.patchCustom(`picados/${picadoId}/confirmar`, payload),
        onSuccessCallback: (commit, data) => {
          commit("updateItem", data);
          return data;
        },
        errorMessage: "Error confirmando picado",
      });
    },
  },
};
